import { Injectable } from '@angular/core';
import { ActionBackOfficeResponse } from '../../models/api.model';
import {
  SaveSiteQuotaConfigPayload,
  SiteQuotaConfig,
} from '../../models/card-quota/site-quota-config.model';

@Injectable({ providedIn: 'root' })
export class MapperSiteQuotaConfigService {
  mapConfig(dto: SiteQuotaConfig & Record<string, unknown>): SiteQuotaConfig {
    return {
      id: Number(dto.id ?? dto['Id'] ?? 0),
      siteId: Number(dto.siteId ?? dto['SiteId'] ?? 0),
      siteName: String(dto.siteName ?? dto['SiteName'] ?? ''),
      distributionMode: String(dto.distributionMode ?? dto['DistributionMode'] ?? 'direct'),
      distributorClientId:
        dto.distributorClientId != null ? Number(dto.distributorClientId ?? dto['DistributorClientId']) : null,
      distributorClientName: String(dto.distributorClientName ?? dto['DistributorClientName'] ?? ''),
      allocationRequiresApproval: Boolean(
        dto.allocationRequiresApproval ?? dto['AllocationRequiresApproval'] ?? false
      ),
      tenantCanSelfManage: Boolean(dto.tenantCanSelfManage ?? dto['TenantCanSelfManage'] ?? false),
      returnQuotaOnNaturalExpiry: Boolean(
        dto.returnQuotaOnNaturalExpiry ?? dto['ReturnQuotaOnNaturalExpiry'] ?? true
      ),
    };
  }

  mapToPayload(config: SiteQuotaConfig, userId: number, menuId: number): SaveSiteQuotaConfigPayload {
    return {
      userId,
      menuId,
      id: config.id > 0 ? config.id : null,
      siteId: config.siteId,
      distributionMode: config.distributionMode,
      distributorClientId: config.distributionMode === 'via_distributor' ? config.distributorClientId : null,
      allocationRequiresApproval: config.allocationRequiresApproval,
      tenantCanSelfManage: config.tenantCanSelfManage,
      returnQuotaOnNaturalExpiry: config.returnQuotaOnNaturalExpiry,
    };
  }

  mapActionResponse(res: unknown): ActionBackOfficeResponse {
    const raw = (res ?? {}) as Record<string, unknown>;
    return {
      isSuccess: Boolean(raw['isSuccess'] ?? raw['IsSuccess'] ?? false),
      message: String(raw['message'] ?? raw['Message'] ?? ''),
      messageEn: String(raw['messageEn'] ?? raw['MessageEn'] ?? ''),
      code: String(raw['code'] ?? raw['Code'] ?? ''),
      IdReturn: Number(raw['IdReturn'] ?? raw['idReturn'] ?? 0),
    };
  }
}
